import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface BooleanQuestionProps {
  label: string;
  value: boolean | null;
  onChange: (value: boolean) => void;
  detailValue?: string;
  onDetailChange?: (value: string) => void;
  detailPlaceholder?: string;
}

export function BooleanQuestion({
  label,
  value,
  onChange,
  detailValue,
  onDetailChange,
  detailPlaceholder,
}: BooleanQuestionProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-4">
        <Label className="text-sm">{label}</Label>
        <div className="flex gap-1">
          <button
            type="button"
            onClick={() => onChange(true)}
            className={cn(
              "rounded-md px-3 py-1 text-xs font-medium transition-colors border",
              value === true
                ? "bg-primary text-primary-foreground border-primary"
                : "bg-background text-muted-foreground border-border hover:border-primary/50"
            )}
          >
            Sí
          </button>
          <button
            type="button"
            onClick={() => onChange(false)}
            className={cn(
              "rounded-md px-3 py-1 text-xs font-medium transition-colors border",
              value === false
                ? "bg-destructive/10 text-destructive border-destructive/30"
                : "bg-background text-muted-foreground border-border hover:border-destructive/50"
            )}
          >
            No
          </button>
        </div>
      </div>
      {value === true && onDetailChange && (
        <Input
          placeholder={detailPlaceholder}
          value={detailValue ?? ""}
          onChange={(e) => onDetailChange(e.target.value)}
          className="text-sm"
        />
      )}
    </div>
  );
}
